import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.33359 8.00026H10.6669M8.00026 5.33359V10.6669M14.6669 8.00026C14.6669 11.6822 11.6822 14.6669 8.00026 14.6669C4.31836 14.6669 1.33359 11.6822 1.33359 8.00026C1.33359 4.31836 4.31836 1.33359 8.00026 1.33359C11.6822 1.33359 14.6669 4.31836 14.6669 8.00026Z",
      stroke: "currentColor",
      "stroke-width": "1.3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }